// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "ed971a4d1be3a314","396": "079a69cd64d7e5db","460": "7be62e6eeaa24a79","917": "be7d5466817f4fb2","985": "8a3b3afa0662edb2",}[chunkId] + ".chunk.js"
}